import React from 'react';
import './Notfound.css';


import Helmet from '../../component/Helmet/Helmet';
import Sidebar from '../../component/layouts/Sidebar';
import MobileTopBar from '../../component/layouts/MobileTopBar';
import RightSide from '../../component/layouts/rightSide';

const Notfound = () => {
  return (
  <Helmet title='Notfound'>
    <div className="Notfound">
  
    <Sidebar/>

    <div className='midSide'>
    <div className='middleSideHome'>
     
     <MobileTopBar/>
      
      {/* Start Main Section */}

        <div className='mainSection'>
           <h2>Not Found Page</h2>
        </div>
    </div>
    </div>
    
    <RightSide/>

  </div>
  </Helmet>
  );
};

export default Notfound;